import { Component, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { FileModel } from 'src/app/pages/project-request/models/file.model';

@Component({
  selector: 'app-modal-files',
  templateUrl: './modal-files.component.html',
  styleUrls: ['./modal-files.component.scss']
})
export class ModalFilesComponent implements OnInit {

  @ViewChild("modal") modal!: ElementRef;
  @Input() onlyPreview: boolean;
  @Output() saveModal: EventEmitter<any> = new EventEmitter();
  @Output() closeModal: EventEmitter<any> = new EventEmitter();

  modalReference: NgbModalRef | null = null;

  files: FileModel[];
  selectedFile: FileModel | null;
  filesAction: { upload: any[], delete: any[] };

  constructor(protected modalSrv: NgbModal,
    public sanitizer: DomSanitizer) {
    this.onlyPreview = false;
    this.files = [];
    this.selectedFile = null;
    this.filesAction = { upload: [], delete: [] };
  }

  ngOnInit(): void {
    this.files = [];
    this.selectedFile = null;
    this.filesAction = { upload: [], delete: [] };
  }

  /**
   * @description Open Modal
   * @param files 
   */
  open(files: FileModel[]): void {
    this.files = [];
    this.selectedFile = null;
    this.filesAction = { upload: [], delete: [] };

    files.forEach(f => {
      if (!f.deleted) {
        const file = new FileModel(f);
        if (!file.urlSanitize) file.urlSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(`${file.url}?preview=true`);
        this.files.push(file);
      }
    });

    if (files && files[0] && (files[0].mimetype == 'pdf' || files[0].mimetype == 'png' || files[0].mimetype == 'jpeg' || files[0].mimetype == 'jpg')) {
      this.selectFile(files[0]);
    }

    this.modalReference = this.modalSrv.open(this.modal, { centered: true, size: 'xl', backdrop: 'static', keyboard: false });
  }

  /**
   * @description Select files (dropzone)
   * @param event
   */
  onSelect(event: any) {
    event.addedFiles.forEach(async (f: File) => {
      const urlSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(encodeURI(URL.createObjectURL(f)));
      const fileAPI = new FileModel().createFromFile(f, urlSanitize);
      this.files.push(fileAPI);
      this.filesAction.upload.push({ api: fileAPI, file: f });
    });
  }

  onRemove(index: number) {
    const resp = this.files.splice(index, 1);
    const file = resp && resp.length > 0 ? resp[0] : null;
    if (!file!.id.toString().includes('#new')) this.filesAction.delete.push(file);
    this.filesAction.upload = this.filesAction.upload.filter((f: any) => file && f.api.id !== file.id);
  }

  /**
   * returns preview url of file
   * @param f file
   */
  getPreviewUrl(f: File) {
    return this.sanitizer.bypassSecurityTrustResourceUrl(encodeURI(URL.createObjectURL(f)));
  }

  selectFile($event: any) {
    this.selectedFile = $event;
    if (this.selectedFile && !this.selectedFile.urlSanitize) this.selectedFile.urlSanitize = this.sanitizer.bypassSecurityTrustResourceUrl(`${this.selectedFile.url}?preview=true`);
  }

  /**
   * @description Open File Preview inside a new tab
   */
  async openTabPreview() {
    if (this.selectedFile) {
      window.open(`${this.selectedFile.url}?preview=true`, "_blank");
    }
  }


  save() {
    const result = {
      form: this.files,
      upload: this.filesAction.upload.map((f: any) => f.file),
      delete: this.filesAction.delete,
      uploadOriginal: this.filesAction.upload
    };
    this.modalReference!.close();
    this.saveModal.emit(result);
  }

  close() {
    this.modalReference!.close();
    this.closeModal.emit();
  }
}
